import React from "react"
import { Card, Form } from "react-bootstrap"

const Promotions = ({ promotions, value, onChange }) => {

  return (
    <div>
      <Card.Text as='h6'><strong>Select Promotion</strong></Card.Text>
    <Card className="text-center">
      <Card.Body>
          <Card.Title as='h4'>
          <Form.Control as="select" required  value={value}
          onChange={onChange}
          >{
            promotions.map((x,index)=>(                
                <option key={index} data-discount={x.discount}  value={x.name} data-campaign-id={x.id}>
                  {x.name}
                </option>
              ))
            }
          </Form.Control> 
          </Card.Title>
      </Card.Body>
    </Card>
    </div>
  )
}

export default Promotions
